import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable, of, tap } from 'rxjs';

import { PermissionsStorageService } from '../services/permissions-storage.service';
import { UserStateService } from '../services/users/user-state.service';
import { UserGQLService } from '../services/users/user.graphql.service';
import { checkCookie } from '../utilities/cookies';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private userStateService: UserStateService,
    private userGQLService: UserGQLService,
    private permissionsService: NgxPermissionsService,
    private permissionsStorageService: PermissionsStorageService,
    private router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean> {
    if (checkCookie('SC_AUTH') && this.userStateService.user === undefined) {
      this.userGQLService
        .getLoggedInUser()
        .pipe(
          tap((user) => {
            this.userStateService.user = user;

            const userPermissions = user.permissions;
            const permissions = userPermissions?.map((permission) => {
              return permission.name;
            });

            this.permissionsService.addPermission(permissions as string[]);
            this.permissionsService.loadPermissions(permissions as string[]);

            this.permissionsStorageService.permissions = permissions ?? [];
          }),
        )
        .subscribe();
    }

    if (checkCookie('SC_AUTH')) {
      return of(true);
    }

    this.router.navigate(['/login']).catch((error: unknown) => {
      console.error(error);
    });
    return of(false);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
